import type { ComponentProps, ReactElement } from "react"

import { Ripple } from "~/shared/ui/kit"
import { Href } from "~/shared/ui"

import cssModule from "./index.module.scss"
import { cx } from "classix"


export type FooterLink = {
	url: string
	icon: ReactElement
	title: string | ReactElement
}

export function FooterLinks({
	links,
	...props
}: { links: FooterLink[] } & ComponentProps<"div">) {

	const hasLinks = links.length > 0

	return (
		<div
			className={cx(cssModule.linkGroup)}
			style={{
				height: `${hasLinks ? "12rem" : "0"}`,
				opacity: `${hasLinks ? "1" : "0"}`,
				flex: `${hasLinks ? "1" : "0"} 0 auto`
			}}
			{...props}>
			{links.map(({ url, icon, title }) => {
				const children = (
					<>
						<Ripple color="rgba(1,1,1,0.1)" />
						<div>{icon}</div>
						<div className="inline-block text-[#575d6d]">{title}</div>
					</>
				)

				return (
					<Href key={url} href={url} className={cssModule.link}>
						{children}
					</Href>
				)
			})}
		</div>
	)
}
